import { render, staticRenderFns } from "./LanguageSwitch.vue?vue&type=template&id=033a4780&scoped=true"
import script from "./LanguageSwitch.js?vue&type=script&lang=js&external"
export * from "./LanguageSwitch.js?vue&type=script&lang=js&external"
import style0 from "./LanguageSwitch.scss?vue&type=style&index=0&id=033a4780&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "033a4780",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HotIcon: require('/home/runner/_work/app-hotmart-legal/app-hotmart-legal/components/Atoms/Icon/Icon.vue').default})
